export default {
  contractSections: [],
  contractSection: undefined,
};
